export const getPlatform = () => {
  if (typeof navigator === 'undefined') return 'other';

  const platform =
    (navigator as any).userAgentData?.platform ?? navigator.platform ?? '';

  if (/mac/i.test(platform)) return 'mac';
  if (/win/i.test(platform)) return 'windows';
  if (/linux/i.test(platform)) return 'linux';
  return 'other';
};

export const isPrimaryModifier = (event: KeyboardEvent) => {
  const os = getPlatform();
  if (os === 'mac') return event.metaKey;
  if (os === 'windows' || os === 'linux') return event.ctrlKey;
  // On unknown platforms, we check for both Ctrl and Meta as the primary modifier.
  // This is to maximize compatibility, but may need to be revisited for specific platforms.
  return event.ctrlKey || event.metaKey;
};
